import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListarSecs from '../../components/secretarias';
import ItemBox from '../../components/shared/item_box';


function SecretariasScreen() {
    return (
        <Fragment>
            <Head titulo="Secretarias Municipais da Prefeitura Municipal de Macuco" />
            <Header />
            <Container>
                <ItemBox
                    titulo={"Responsáveis pelo Órgão:"}
                    texto={
                        <Fragment>
                            <p>
                                Cargo: Prefeita <br />
                                Ocupante: Michelle Bianchini Biscácio<br />
                            </p>
                            <hr />
                            <p>
                                Cargo: Vice-Prefeito <br />
                                Ocupante: João Batista da Silva Oliveira<br />
                            </p>
                            <br />
                        </Fragment>
                    }
                />
                <ListarSecs />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SecretariasScreen;